<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a :class="['nav-link', {'active': tab == 0}]" @click="tab = 0">Regionais</a>
      </li>
      <li class="nav-item">
        <a :class="['nav-link', {'active': tab == 1}]" @click="tab = 1">Empresas</a>
      </li>
    </ul>

    <div class='row mt-3'>
      <div class='col-3'>
        <div class='form-group'>
          <label>Início</label>
          <input class='form-control' v-mask="'##/##/####'" v-model="start">
        </div>
      </div>
      <div class='col-3'>
        <div class='form-group'>
          <label>Fim</label>
          <input class='form-control' v-mask="'##/##/####'" v-model="end">
        </div>
      </div>
      <div class='col-3'>
        <div class='form-group'>
          <label>Tipo do documento</label>
          <select class='form-control' v-model="type">
            <option value="TODOS">Todos</option>
            <option value="NORMAL">Documentos Normais</option>
            <option value="FERIAS">Férias</option>
            <option value="RESCISAO">Rescisões</option>
          </select>
        </div>
      </div>
      <div class='col-3'>
        <div class='form-group'>
          <label>Ação</label>
          <button class='btn btn-success btn-block' @click="getData()">Pesquisar</button>
        </div>
      </div>
    </div>

    <HorizontalBar
      v-if="tab == 0 && regionalData && renderRegionalChart"
      id="regionals"
      ref="regionals"
      key="regionals"
      class="charts-horizontal"
      :chart-data="regionalData"
      :options="options"
      :style="{height: (regionalData.labels.length * 25 + 50) + 'px !important'}"
    />
    <HorizontalBar
      v-if="tab == 1 && companyData && renderCompanyChart"
      id="companies"
      ref="companies"
      key="companies"
      class="charts-horizontal"
      :chart-data="companyData"
      :options="options"
      :style="{height: (companyData.labels.length * 25 + 50) + 'px !important'}"
    />
  </div>
</template>

<script>
import HorizontalBar from "@/components/Charts/HorizontalBar.js";

export default {
  data() {
    return {
      type: 'TODOS',
      start: moment().startOf('month').format('DD/MM/YYYY'),
      end: moment().format('DD/MM/YYYY'),
      tab: 0,
      renderRegionalChart: false,
      renderCompanyChart: false,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: true,
            categoryPercentage: 0.5,
            barPercentage: 1
          }],
          yAxes: [{
            stacked: true
          }]
        }
      },
      regionalData: null,
      companyData: null
    };
  },
  methods: {
    calculateData(data, variable) {
      let labels = []
      let signed = []
      let pending = []

      let values = Object.values(data)

      values.sort((a,b) => (a.counts.percentage > b.counts.percentage) ? -1 : ((b.counts.percentage > a.counts.percentage) ? 1 : 0))

      values.forEach(value => {
        labels.push(value.name)
        signed.push(value.counts.percentage)
        pending.push(100 - value.counts.percentage)
      });
      
      this[variable] = {
        type: "horizontalBar",
        labels: labels,
        datasets: [
          {
            label: 'Concluídos',
            backgroundColor: 'green',
            data: signed
          },
          {
            label: 'Pendentes',
            backgroundColor: 'lightgray',
            data: pending
          }
        ]
      }
    },
    formatDate(date){
      return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
    },
    getRegionalData(){
      const self = this;
      const api = self.$store.state.api + "signedPercentageByRegional?start=" + self.formatDate(self.start) 
        + "&end=" + self.formatDate(self.end)
        + "&type=" + self.type;
      self.$http
        .get(api)
        .then(response => {
          self.calculateData(response.data, 'regionalData');
          self.renderRegionalChart = true
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        }); 
    },
    getCompanyData(){
      const self = this;
      const api = self.$store.state.api 
        + "signedPercentageByCompany?start=" + self.formatDate(self.start) 
        + "&end=" + self.formatDate(self.end)
        + "&type=" + self.type;
      self.$http
        .get(api)
        .then(response => {
          self.calculateData(response.data, 'companyData');
          self.renderCompanyChart = true
        })
        .catch(error => {
          self.$message("Erro", error.response.data, "error");
        }); 
    },
    convertHex(hex, opacity) {
      hex = hex.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      const result =
        "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
      return result;
    },
    getData(){
      this.renderRegionalChart = false
      this.renderCompanyChart = false

      this.getRegionalData();
      this.getCompanyData();
    }
  },
  mounted(){
    this.getData()
  },
  components: {
    HorizontalBar,
  }
};
</script>
<style>
  .charts-horizontal {
    margin: 30px;
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Regionals.vue